import apolloClient from '../apolloClient';
import {
  GET_CAMPAIGN_KIOSKS,
  GET_CAMPAIGN_BILLING_INFO,
  GET_CAMPAIGN_USERS
} from './queries/campaignDetails';

/**
 * Fetch campaign kiosks/placements with pagination support
 */
export const fetchCampaignKiosksGraphQL = async (campaignId, paginationOptions = {}) => {
  try {
    const { first, last, after, before } = paginationOptions;
    
    // Default to first: 5 if no pagination options provided
    const variables = { 
      campaignId: parseInt(campaignId, 10),
      first: first !== undefined ? first : (last === undefined ? 5 : undefined),
      last,
      after,
      before
    };
    
    const { data } = await apolloClient.query({
      query: GET_CAMPAIGN_KIOSKS,
      variables,
      fetchPolicy: 'network-only'
    });

    return data.campaignKiosks || { edges: [], pageInfo: {}, totalCount: 0 };
  } catch (error) {
    console.error('Error fetching campaign kiosks:', error);
    throw error;
  }
};

/**
 * Fetch campaign billing info
 */
export const fetchCampaignBillingInfoGraphQL = async (campaignId) => {
  try {
    const { data } = await apolloClient.query({
      query: GET_CAMPAIGN_BILLING_INFO,
      variables: { campaignId: parseInt(campaignId, 10) },
      fetchPolicy: 'network-only'
    });

    return data.campaignBillingInfo?.[0] || null;
  } catch (error) {
    console.error('Error fetching campaign billing info:', error);
    throw error;
  }
};

/**
 * Fetch campaign team/users
 */
export const fetchCampaignUsersGraphQL = async (campaignId) => {
  try {
    const { data } = await apolloClient.query({
      query: GET_CAMPAIGN_USERS,
      variables: { campaignId: parseInt(campaignId, 10) },
      fetchPolicy: 'cache-first'
    });

    return data.campaignUsers || [];
  } catch (error) {
    console.error('Error fetching campaign users:', error);
    throw error;
  }
};

